import { peopleApi, dealsApi, issuesApi } from '../../api/crm';
import { readQueuePages } from '../../utils/myDay';
import type { RoleProfile } from '../../utils/roleProfile';

// Query options shared by the sales home's hero and sections. Keys carry the
// identity, profile, CRM scope and grant fingerprint so a different account or
// grant set never reuses another's cache. Counts come from the server.
export interface SalesScope { profile: RoleProfile; userId?: number; vertical: number | 'all'; accessKey: string }
export const hangingQuietDays = 14;

export function salesQueries(scope: SalesScope) {
  const enabled = scope.profile === 'sales';
  const verticalId = scope.vertical === 'all' ? undefined : scope.vertical;
  const key = (name: string) => [name, scope.profile, scope.userId, scope.vertical, scope.accessKey];
  return {
    contacts: { queryKey: key('my-day-owned-contacts'), enabled, queryFn: () => peopleApi.list({ owner_id: 'me', vertical_id: verticalId, per_page: 1, page: 1 }), staleTime: 60000 },
    openDeals: { queryKey: key('my-day-owned-deals'), enabled, queryFn: () => readQueuePages(page => dealsApi.list({ owner_id: 'me', open_only: 'true', vertical_id: verticalId, page, per_page: 100 })), staleTime: 60000 },
    closedDeals: { queryKey: key('my-day-owned-lifecycle'), enabled, queryFn: () => readQueuePages(page => dealsApi.list({ owner_id: 'me', open_only: 'false', vertical_id: verticalId, page, per_page: 100 })), staleTime: 60000 },
    issues: { queryKey: key('my-day-owned-issues'), enabled, queryFn: () => issuesApi.list({ contact_owner_id: 'me', open_only: 'true', vertical_id: verticalId, per_page: 5, page: 1 }), staleTime: 60000 },
    hanging: { queryKey: key('my-day-b2b-hanging'), enabled, queryFn: () => peopleApi.list({ owner_id: 'me', b2b: 'true', quiet_days: hangingQuietDays, vertical_id: verticalId, per_page: 5, page: 1 }), staleTime: 60000 }
  };
}
